import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    iconButton: {
        color: '#35465c'
    },
    stateButton: {
        textDecoration: 'underline',
        textUnderlineOffset: '4px',
        '& :hover': {
            textDecoration: 'underline',
            textUnderlineOffset: '4px',
        }
    }
}))